import React from "react";
import LoginIcon from "../../assets/image/logo.png";
import { useNavigate } from "react-router-dom";

const PasswordSuccessful = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className={`h-screen overflow-hidden relative`}>
        <div className={`flex items-center justify-center h-full`}>
          <section className="w-full">
            <div className="max-w-xl w-full mx-auto">
              <div className="flex justify-center mb-4">
                <img src={LoginIcon} alt="logo" className="object-cover w-40" />
              </div>
              <div className="rounded-lg drop-shadow-lg bg-white/80 px-6 py-8 mx-4 border border-gray shadow-lg">
                <div className={"mb-8"}>
                  <h1 className="sm:text-2xl text-2xl text-primaryBlack font-Montserrat font-normal mb-1">
                    Password Successful Updated!
                  </h1>
                  <p className="text-sm text-textSecondary font-normal font-Proxima">
                    Login now
                  </p>
                </div>
                <button
                  type="submit"
                  className="w-full block text-bgWhite font-normal bg-themeBtn text-center text-[15px] border-2 border-transparent uppercase hover:bg-transparent hover:border-2 hover:border-themeBtn hover:text-themeBtn rounded transition duration-500 py-2 lg:px-7 px-4 mt-3"
                  onClick={() => {
                    navigate("/login");
                  }}
                >
                  Go to login
                </button>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default PasswordSuccessful;
